import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { TreeNode, TreeTableComponent } from '@farris/ui-treetable';
import { ExpressionEditorLocalePipe } from '../utils/expression-editor-locale.pipe';
import { Schema } from '../common/Schema';
import { NewSchema } from '../common/NewSchema';
import { SchemaToStructUtils } from "../checkSyntax/SchemaToStruct";
import { CurrentNode, InjectedEntity } from '../common/ExpressEntity';

const EnumFunctionCode = "ParseEnum";   //枚举函数编号

@Component({
  selector: 'app-expression-entity-grid',
  templateUrl: './expression-entity-grid.component.html',
  styleUrls: ['./expression-entity-grid.component.css']
})
export class ExpressionEntityGridComponent implements OnInit, OnChanges {

  //定义i18n标识
  private localeId: string;
  private localePipe: ExpressionEditorLocalePipe;

  currentNode: CurrentNode = new CurrentNode;
  entities: TreeNode[] = [];
  currentSchemaName: string = "";
  currentNewSchemaName: string = "";
  currentParent: string = "";
  @Input() schema = new Map<string, Schema>();
  @Input() newSchemaMap = new Map<string, NewSchema>();
  @Input() injectedEntities: InjectedEntity[];
  @Input() showChildSymbol: boolean = true;           //是否展示[0]
  @Output() selectentitychange = new EventEmitter();
  @Output() dbclickInsert = new EventEmitter();

  @ViewChild('operCell') operCell: TemplateRef<any>;  //定义按钮操作
  @ViewChild('tt') tt: TreeTableComponent;            //使用farris-treetable特性

  cols = [];
  allColumnsTitle: string = "";                       //搜索框'所有列'显示信息
  searchFields = [];                                  //搜索框可以使用哪些字段
  public treedata: TreeNode[] = [];

  //资源国际化
  i18nTypes: Map<string, string> = new Map();   //参数类型

  constructor() {
    //初始化i18n标识
    this.localeId = localStorage.getItem('languageCode') || 'zh-CHS';
    this.localePipe = new ExpressionEditorLocalePipe(this.localeId);
    this.i18nTypes.clear();
    this.i18nTypes.set("String", this.localePipe.transform("NewDataTypeString"));
    this.i18nTypes.set("Byte", this.localePipe.transform("NewDataTypeByte"));
    this.i18nTypes.set("Boolean", this.localePipe.transform("NewDataTypeBoolean"));
    this.i18nTypes.set("Date", this.localePipe.transform("NewDataTypeDate"));
    this.i18nTypes.set("DateTime", this.localePipe.transform("NewDataTypeDateTime"));
    this.i18nTypes.set("Decimal", this.localePipe.transform("NewDataTypeDecimal"));
    this.i18nTypes.set("Integer", this.localePipe.transform("NewDataTypeInteger"));
    this.i18nTypes.set("Enum", this.localePipe.transform("NewDataTypeEnum"));
    this.i18nTypes.set("EntityType_Main", this.localePipe.transform("EntityType_Main"));
    this.i18nTypes.set("EntityType_ChildTable", this.localePipe.transform("EntityType_ChildTable"));
    this.i18nTypes.set("EntityType_Other", this.localePipe.transform("EntityType_Other"));
    this.i18nTypes.set("EntitySet", this.localePipe.transform("EntitySet"));
    this.i18nTypes.set("EntityEnum", this.localePipe.transform("EntityEnum"));
    this.i18nTypes.set("EntityEnum_Int", this.localePipe.transform("EntityEnum_Int"));
    this.i18nTypes.set("EntityEnum_String", this.localePipe.transform("EntityEnum_String"));
  }
  ngOnInit() {
    this.cols = [
      { field: 'code', title: this.localePipe.transform("EntityCode"), width: '5' },
      { field: 'name', title: this.localePipe.transform("EntityName"), width: '5' },
      { field: 'type.description', title: this.localePipe.transform("EntityType"), width: '2' },
      { title: this.localePipe.transform("InsertType"), width: '3', align: 'center', halign: 'center', template: this.operCell }
    ];
    this.searchFields = [
      { label: this.localePipe.transform("EntityCode"), value: "code" },
      { label: this.localePipe.transform("EntityName"), value: "name" }
    ]
    this.allColumnsTitle = this.localePipe.transform("EntityAllColumn");
  }
  selectRowChange($event) {
    this.currentNode = new CurrentNode;
    this.currentNode.id = $event.node.data.id;
    this.currentNode.code = $event.node.data.code;
    this.currentNode.name = $event.node.data.name;
    this.currentNode.nodeType = $event.node.data.nodeType;
    this.currentParent = this.selectParentString($event.node);

    this.selectentitychange.emit(this.currentNode);
  }

  ngOnChanges() {
    if (this.newSchemaMap && this.newSchemaMap.size > 0) {
      this.treedata = SchemaToStructUtils.onInitNewSchema(this.newSchemaMap, this.injectedEntities, this.i18nTypes);
    } else if (this.schema && this.schema.size > 0) {
      this.treedata = SchemaToStructUtils.OnInitSchema(this.schema, this.injectedEntities, this.i18nTypes);
    }
    this.treedata = [...this.treedata];
  }
  //递归父节点名
  selectParentString(node: any) {
    if (node.parent) {
      if (this.selectParentString(node.parent)) {
        if (this.strContain(node.parent.data.type.code) && this.showChildSymbol)
          return this.selectParentString(node.parent) + "." + node.parent.data.code + "[0]";
        else
          return this.selectParentString(node.parent) + "." + node.parent.data.code;
      } else if (this.strContain(node.parent.data.type.code) && this.showChildSymbol) {
        return node.parent.data.code + "[0]";
      } else {
        return node.parent.data.code;
      }
    } else {
      return "";
    }
  }

  //同insertByStructure
  dblClick($event) {
    this.insertByStructure($event);
  }

  //"按结构"按钮
  insertByStructure(node) {
    this.currentParent = this.selectParentString(node);
    if (this.currentParent && this.currentParent != "") {
      this.submit(this.currentParent + "." + node.data.code);
    } else {
      this.submit(node.data.code);
    }
  }

  //"按属性"按钮
  insertByProperty(node) {
    this.submit(node.data.code);
  }

  //枚举插值
  insertByEnum(node, isParent: boolean) {
    this.currentParent = this.selectParentString(node);
    let params: string[] = [];
    let judgeValue;
    if (isParent) {
      //父节点
      params[0] = this.currentParent + "." + node.data.code;
    } else {
      params[0] = this.currentParent;
      if (node.data.type.code == Type.EntityEnum_String) {
        judgeValue = "\"" + node.data.name + "\"";
      } else {
        judgeValue = node.data.name;
      }
    }
    params[1] = "Enum$" + params[0];

    //"."替换为"$"
    while (params[1].includes(".")) {
      params[1] = params[1].replace(".", "$");
    }
    this.submit(node, EnumFunctionCode, params, !isParent, judgeValue);
  }

  //向父组件提交数据
  submit(data, func: string = null, params: string[] = null, judge: boolean = null, judgeValue: any = null) {
    //拼接参数
    let paramStr;
    if (params != null && params.length > 0) {
      paramStr = "";
      for (let i = 0; i < params.length; i++) {
        if (i == 0) {
          paramStr += params[i];
        } else {
          paramStr += ",";
          paramStr += params[i];
        }
      }
    }

    //组织提交数据
    let arg = {
      data: data,     //节点
      func: func,
      params: paramStr,
      judge: judge,
      judgeValue: judgeValue
    };
    this.dbclickInsert.emit(arg);
  }

  private strContain(typeCode: Type): boolean {
    if (typeCode == Type.EntitySet)
      return true;
    else
      return false;
  }

  //过滤
  filter($event) {
    //通过farris-treetable的方法过滤
    this.tt.searchHandle.search($event.field, $event.value, 'client')
  }

}
export enum Type {
  Boolean = "Boolean",
  Byte = "Byte",
  Integer = "Integer",
  Decimal = "Decimal",
  Date = "Date",
  DateTime = "DateTime",
  String = "String",
  EntityType_Main = "EntityType_Main",
  EntityType_ChildTable = "EntityType_ChildTable",
  EntityType_Other = "EntityType_Other",
  EntitySet = "EntitySet",
  EntityEnum = "EntityEnum",
  EntityEnum_Int = "EntityEnum_Int",
  EntityEnum_String = "EntityEnum_String",
}